/* eslint
    no-empty-function: "warn",
    @typescript-eslint/no-shadow: "warn"
*/

import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';
import { hide, hideAll } from '@shared/easyfy.utils';
import formService from '@inlineServices/form.service';
import easyfyToaster, { MessageSeverity } from '@shared/easyfy.toaster';

namespace Easyfy.Modules {
  @invoke
  class Form {

    onInit() {
      globalEvent({
        type: 'submit',
        event: {
          action: 'ajax-form',
          callback: Form.onPostForm
        }
      });

      globalEvent({
        type: 'submit',
        event: {
          action: 'pre-post',
          callback: Form.onPrePostAction
        }
      });
    }

    static onPostForm = async (e: Event) => {
      e.preventDefault();
      e.stopPropagation();

      const element: HTMLFormElement = e.target as HTMLFormElement;
      const data: FormData = new FormData(element);
      const dataUpdate = 'data-update';
      const dataHiddenValue = 'data-hidden-value';
      const dataMessageContainer = element.getAttribute('data-message') ?? undefined;
      const messageContainer = element.querySelector(`[data-container="${dataMessageContainer}"]`) as HTMLElement;

      formService.PostForm(element.getAttribute('action') ?? undefined, data).then(response => {
        if (messageContainer) {
          easyfyToaster.toaster(response.data.success ? MessageSeverity.success : MessageSeverity.error, response.data.message, messageContainer);
        } else {
          easyfyToaster.toaster(response.data.success ? MessageSeverity.success : MessageSeverity.error, response.data.message);
        }

        if (response.data.success) {
          if (response.data.partial) {
            const updateContainer = element.getAttribute(dataUpdate) ?? undefined;
            const container = document.querySelector(`[data-container="${updateContainer}"]`);

            if (container) {
              container.innerHTML = response.data.partial;

              // clear field for next form load
              const hiddenValue = element.querySelector<HTMLInputElement>(`[${dataHiddenValue}]`)?.value;
              if (hiddenValue) {
                element.setAttribute(dataUpdate, (element.getAttribute(dataUpdate) ?? '').replace(`-${hiddenValue}`, ''));
              }
            }

            const extraToggleEvent = element.getAttribute('data-extra-toggle-event');
            if (extraToggleEvent) {
              const dataContainer = document.querySelector(`[data-container="${extraToggleEvent}"]`);
              if (dataContainer) hide(dataContainer);

              const overlayElement: NodeListOf<HTMLElement> = document.querySelectorAll('[data-overlay-container]');
              hideAll(overlayElement);
            }
          } else if (response.data.reload) {
            setTimeout(() => {
              location.reload();
            }, 700);
          }
        }
      });

      return false;
    };

    static onPrePostAction = async (e: Event) => {
      e.preventDefault();
      e.stopPropagation();

      const form: HTMLFormElement = e.target as HTMLFormElement;
      const data: FormData = new FormData(form);
      const dataMessageContainer = form.getAttribute('data-message') ?? undefined;
      const messageContainer = form.querySelector(`[data-container="${dataMessageContainer}"]`) as HTMLElement;
      const validationMethod = form.getAttribute('data-validate-method') ?? undefined;

      if (!validationMethod) {
        return false
      };

      formService.PostForm(validationMethod, data).then(response => {
        if (response.data.success) {
          form.submit();
        }
        else if (messageContainer) {
          easyfyToaster.toaster(response.data.success ? MessageSeverity.success : MessageSeverity.error, response.data.message, messageContainer);
        } else {
          easyfyToaster.toaster(response.data.success ? MessageSeverity.success : MessageSeverity.error, response.data.message);
        }
      });

      return false;
    };
  }
}
